import { useIsAuth } from 'feature/auth/hooks'
import { ReactNode } from 'react'
import { Navigate } from 'react-router'

interface Props {
  children: ReactNode
}

export function RequireAuth({ children }: Props) {
  const isAuth = useIsAuth()

  if (!isAuth) return <Navigate to='/' replace />

  return <>{children}</>
}
